module.exports = __webpack_public_path__ + "static/media/industries-mortar-s.ad82eb37.webp";